export default __webpack_public_path__ + "static/media/arrow-right.inline.6ff87fef.svg";